import { render, staticRenderFns } from "./FK4151Component.vue?vue&type=template&id=0a16a140&scoped=true&"
import script from "./FK4151Component.vue?vue&type=script&lang=js&"
export * from "./FK4151Component.vue?vue&type=script&lang=js&"
import style0 from "./FK4151Component.vue?vue&type=style&index=0&id=0a16a140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16a140",
  null
  
)

export default component.exports